import { render, staticRenderFns } from "./LearningCalendar.vue?vue&type=template&id=086f3950&scoped=true&"
import script from "./LearningCalendar.vue?vue&type=script&lang=ts&"
export * from "./LearningCalendar.vue?vue&type=script&lang=ts&"
import style0 from "./LearningCalendar.vue?vue&type=style&index=0&id=086f3950&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "086f3950",
  null
  
)

export default component.exports